module.exports = __webpack_public_path__ + "img/staff-steve-tassone.036abc4e.jpg";